import wrapError from "@/components/helpers/wrapError"
import wrapSuccess from "@/components/helpers/wrapSuccess"

export const apiGetOutboundMessages = (page, pageSize, success, error) => {
  const finalPageSize = pageSize || 10

  $.ajax({
    type: "GET",
    url: `/api/admin/outboundMessageHistory?page=${page}&pageSize=${finalPageSize}`,
    success,
    error: wrapError(error, "apiGetOutboundMessages"),
  })
}

export const sendAdminEmail = (params, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/admin/adminEmailManager",
    timeout: 120000,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success,
    error: wrapError(error, "sendAdminEmail"),
  })
}

export const apiGetSelectedRecipients = (params, success, error) => {
  $.ajax({
    type: "GET",
    url: "/api/admin/recipientsManager",
    dataType: "JSON",
    data: params,
    success,
    error: wrapError(error, "apiGetSelectedRecipients"),
  })
}

export const fetchEmailDrafts = (constituentId, success, error) => {
  $.ajax({
    type: "GET",
    url: `/api/admin/emailDrafts/${constituentId}`,
    contentType: "application/json; charset=utf-8",
    success: wrapSuccess(success),
    error: wrapError(error, "fetchEmailDrafts"),
  })
}

export const apiAddEmailDraft = (data, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/admin/emailDrafts",
    dataType: "JSON",
    data,
    success,
    error: wrapError(error, "apiAddEmailDraft"),
  })
}

export const apiDeleteEmailDraft = (params, success, error) => {
  const { constituentId, draftId } = params

  $.ajax({
    type: "DELETE",
    url: "/api/admin/emailDrafts",
    dataType: "JSON",
    data: { constituentId, draftId },
    success,
    error: wrapError(error, "apiDeleteEmailDraft"),
  })
}

export const apiUpdateEmailDraft = (data, success, error) => {
  $.ajax({
    type: "PUT",
    url: "/api/admin/emailDrafts",
    dataType: "JSON",
    data,
    success,
    error: wrapError(error, "apiUpdateEmailDraft"),
  })
}
